<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;

  }
</style>
<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/master">Master module</a></li>
      <li class="breadcrumb-item active" aria-current="page">Gender</li>
    </ol>
  </nav>
</div>


<div class="container mt-2 themeTblReso">
  <div class="row">
    <div class="col-md-8">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text cyan lighten-2" id="basic-text1"><i class="fa fa-search text-white"
              aria-hidden="true"></i></span>
        </div>

        <input class="form-control" type="text" placeholder="Search" aria-label="Search" [(ngModel)]="text">
      </div>

    </div>


  <div class="col-md-4" style="justify-content: right;">
    <input type="button" value="Add New" *ngIf="isWrite" class="custbtn" routerLink="/corporate/newgender" >
    <button class="csvBtn ml-1" *ngIf="isImport" (click)="importFile()">
      <img class="customimg" src="../../../assets/custom/images/import.png" style="height: 45px; margin-top: -8px;">
    </button>
    <button class="csvBtn" *ngIf="isExport"  (click)="exportFile()">
      <img class="customimg" src="../../../assets/custom/images/export.png" style="height: 45px; margin-top: -8px;">
    </button>
  </div>
  </div>
<div class="tblPrt">
  <table class="mt-1 bdrStCustom" width="" cellpadding="0" cellspacing="0">

      <tr>
        <!-- <th>Theme Id</th> -->
        <th (click)="chgord('subc1')" class="curPoint" width="10%">Gender Name <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
        <th (click)="chgord('subc1')" class="curPoint" >Gender Description <i class="fa fa-sort text-black" aria-hidden="true"></i></th>


        <th width="10%">Gender Icon</th>

        <th width="10%">Created by</th>

        <!--<th width="200">ModifiedBy</th>-->
        <th width="20%">Created Date</th>
        <th style="text-align: center;" width="25%" *ngIf="isEdit || isDelete">Actions</th>
      </tr>

      <tr *ngFor="let obj of genderObj | filter:text | orderBy:colname:ord | paginate:{itemsPerPage:5,currentPage:cp }">
        <!-- <td>{{obj.get_master_theme.theme_id}}</td> -->
        <td>{{obj.sex_name}}</td>
        <td>{{obj.sex_desc}}</td>
<!--        <td>{{obj.sex_icon}}</td>-->
        <!-- <td>{{obj.get_master_theme.isactive }}</td> -->
        <td><img [src]="obj.sex_icon" alt="Not Found" (error)="setValue($event)"
                 style="height:50px;"></td>
        <td class="nowrp">{{obj.createdname}}</td>
        <td>{{obj.createdon | date:'medium' }}</td>
        <!--<td>{{obj.get_master_theme.modifiedname }}</td>
        <td>{{obj.get_master_theme.modifiedon |date}}</td>-->

        <td *ngIf="isEdit || isDelete">
          <div class="actBtn">
          <i class="curPoint fa fa-edit mr-1" *ngIf="isEdit"  (click)="editGender(obj.sexid)"></i>
          <span class="curPoint fa fa-trash mr-1" *ngIf="isDelete" (click)="deleteGender(obj.sexid)"></span>
          <mat-slide-toggle class="my-slider" [checked]="obj.isactive" *ngIf="isEdit"
            (change)="updateGenderStatus($event,obj.sexid)">
          </mat-slide-toggle>
          </div>
        </td>
        </tr>


    </table>
    <pagination-controls class="my-pagination" (pageChange)="cp=$event"></pagination-controls>
  </div>
  </div>

